import Marquee from "react-fast-marquee";

// Caution-tape ticker — black text on a solid yellow band, framed by thin
// hazard-stripe edges above and below so it reads like tape across the page.
export default function Ticker({
  text = "YAZA",
  repeat = 12,
  speed = 60,
  direction = "left",
  accent = false, // kept for API compatibility; no visual difference now
  className = "",
}) {
  const items = Array.from({ length: repeat });
  return (
    <div className={`bg-black ${className}`} data-testid="marquee-ticker">
      <div className="hazard-stripes-thin h-2" />
      <div className="bg-yaza-accent py-3 md:py-4">
        <Marquee speed={speed} direction={direction} autoFill gradient={false}>
          {items.map((_, i) => (
            <span
              key={i}
              className="font-display text-5xl md:text-7xl leading-none px-8 text-black select-none"
            >
              {text}
            </span>
          ))}
        </Marquee>
      </div>
      <div className="hazard-stripes-thin h-2" />
    </div>
  );
}
